<!-- 扫码标签 -->
<template>
    <div class="addMember">
        <el-dialog
            title="添加标签"
            :visible.sync="show"
            :modal-append-to-body="false"
            width="550px"
            style="'margin-top:50vh;'"
            :close-on-click-modal="false"
            @close="cancelHandle()"
        >
          <el-row :gutter="2">
            <el-col :span="24">
              <el-select
                  v-model="codeForm.groupId"
                  placeholder="选择标签组"
                  size="small"
                  @change="groupChange($event)"
                  style="width: 100%;"
              >
                <el-option :value="item.groupId" :label="item.groupName" v-for="(item,index) in groupList" :key="index"></el-option>
              </el-select>
            </el-col>
        </el-row>
        <el-row :gutter="24" style="margin-top:20px">
            <el-col :span="24">
              <el-checkbox-group v-model="checkedVals">
                  <el-checkbox style="margin-top:10px" v-for="(item,index) in groupTagsList" :key="index" :label="item.tagId+'-'+item.tagName">{{item.tagName}}</el-checkbox>
              </el-checkbox-group>
            </el-col>
        </el-row>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="cancelHandle()">取 消</el-button>
                <el-button type="primary" size="small" @click="confirmHandle()" >确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import {activityTagType} from "@/api/activeCode/activeCode.js";
export default {
  name: "ScanTags",
  props:["tagsDislogVisible","selecteTagsList"],
  data() {
    return {
      show:false,
      codeForm:{
        groupId:""
      },
      groupList:[],//标签组--组名数组
      checkedVals:[],//选中的标签
      groupTagsList:[],//标签组的标签数组
    };
  },
  created() {
  },
  watch:{
    tagsDislogVisible(val){
      this.show = val
      if(val){
        this.getTagsGroups()
      }
    }
  },
  methods: {
    //获取标签组
    getTagsGroups(){
      activityTagType({pageNum:1,pageSize:20},localStorage.getItem("Authorization"),true).then((res)=>{
        if(res.error.code==200){
          this.groupList =  res.data.records;
          this.checkedVals = [];
          if(this.selecteTagsList.length!=0){
            this.selecteTagsList.map(v=>{
              this.checkedVals.push(v.tagId+'-'+v.tagName)
            })
          }
        }
      }).catch((err)=>{})
    },
    // 改变标签组选项事件
    groupChange(id){
      this.groupList.map((item,index)=>{
        if(item.groupId===id){
          this.groupChildentList = item.hmcActivityTagList;
        }
      })
      this.groupTagsList = this.groupList.filter(v=>{
        return v.groupId ==  id
      })[0].hmcActivityTagList
    },
    //取消
    cancelHandle(){
      this.$emit("tagsCloseHandle")
    },
    //确认
    confirmHandle(){
      let resultObj = [];//选择的结果对象数组
      this.checkedVals.map(v=>{
        resultObj.push({
          tagId:v.split("-")[0],
          tagName:v.split("-")[1]
        })
      })
      this.$emit("tagsConfirmHandle",resultObj)
    }
  }
};
</script>
<style lang="scss">
</style>